import { render, staticRenderFns } from "./jingjiren.vue?vue&type=template&id=b7d94fce&scoped=true&"
import script from "./jingjiren.vue?vue&type=script&lang=js&"
export * from "./jingjiren.vue?vue&type=script&lang=js&"
import style0 from "./jingjiren.vue?vue&type=style&index=0&id=b7d94fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d94fce",
  null
  
)

export default component.exports